import { useFlagsQuery } from '@cast/infrastructure-abilities';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

export const useIsEnterpriseCommitmentsEnabled = () => {
  const { currentOrganization, enterpriseOrgId } = useOrganizations();
  const enterpriseId = currentOrganization?.parentId ?? enterpriseOrgId;

  // Backend flag is not fetched among with other flags (it doesn't have the prefix) so we need to fetch it separately
  const { data: flags } = useFlagsQuery({
    flagName: 'pricing-enterprise-commitments',
    // we always check against enterprise org id for pricing enterprise commitments
    organizationId: enterpriseId,
    enabled: !!enterpriseId,
  });

  const isBackendEnterpriseCommitmentsEnabled =
    flags?.some((flag) => flag.boolean) ?? false;

  return isBackendEnterpriseCommitmentsEnabled;
};
